<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="emailFaxForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <kt-alert *ngIf="hasFormErrors" [showCloseButton]="false" type="warn" [duration]="10000">
        {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
      </kt-alert>
      <div class="form-group">
        <div class="row mb-5" *ngIf="!data.reply && !sendDocs">
          <div class="col kt-margin-bottom-20-mobile">
            <div [hidden]="data && data.general_search">
              <mat-form-field
                *ngIf="!data.entityType"
                appearance="outline"
                class="mat-form-field-fluid"
              >
                <mat-label>Type</mat-label>
                <mat-select
                  formControlName="entityType"
                  (selectionChange)="emptyEntities()"
                  [(value)]="selectedInboxType"
                  required
                >
                  <mat-option value="EMAIL"
                    ><span translate="EMAIL_FAX.EMAIL">EMAIL</span></mat-option
                  >
                  <mat-option value="FAX"><span translate="EMAIL_FAX.FAX">FAX</span></mat-option>
                </mat-select>
                <mat-error *ngIf="isControlHasError('entityType', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row mb-5" *ngIf="!data.reply && !sendDocs">
          <div class="col kt-margin-bottom-20-mobile">
            <kt-general-autocomplete
              [label]="'Inbox'"
              [loadItemsFunction]="inboxAutocompleteCall"
              [optionFormatter]="filterInboxFn"
              [valueFormatter]="filterInboxFn"
              [required]="false"
              [control]="emailFaxForm.get('inbox')"
              [change]="onInboxChange.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Select Inbox'"
              [appearance]="'outline'"
              #inboxAutocomplete
              [readOnly]="inboxDisabled"
            ></kt-general-autocomplete>
          </div>
        </div>
        <div class="row mb-5" *ngIf="!data.reply">
          <div class="col kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="outline">
              <mat-label>{{ 'EMAIL_FAX.TO' | translate }}</mat-label>
              <mat-chip-list
                #chipList
                aria-label="Recipient selection"
                [formControl]="emailFaxForm.get('recipients')"
                [disabled]="true"
                required
              >
                <mat-chip
                  *ngFor="let object of emailFaxForm.get('recipients').value"
                  [removable]="false"
                >
                  <div [innerHTML]="optionFormatter(object) | safe : 'html'"></div>
                </mat-chip>
                <input
                  matInput
                  placeholder="Recipient"
                  [readonly]="true"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                />
                <i
                  class="flaticon2-plus fa-xs px-2"
                  (click)="openSelectEntitiesDialog(1); $event.stopPropagation()"
                ></i>
              </mat-chip-list>
              <mat-error *ngIf="isControlHasError('recipients', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-5" *ngIf="!data.reply">
          <div class="col kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="outline">
              <mat-label>{{ 'EMAIL_FAX.SUBJECT' | translate }}</mat-label>
              <input matInput formControlName="subject" required />
              <mat-error *ngIf="isControlHasError('subject', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col kt-margin-bottom-20-mobile">
            <quill-editor
              formControlName="body"
              [modules]="editorOptions"
              [styles]="editorStyle"
            ></quill-editor>
          </div>
        </div>
        <div class="row mb-5" *ngIf="!sendDocs && !data.reply">
          <div class="col kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="outline">
              <mat-label>{{ 'EMAIL_FAX.RELATED_TO' | translate }}</mat-label>
              <mat-chip-list
                #chipList2
                aria-label="Related To Selection"
                [formControl]="emailFaxForm.get('related_to')"
                [disabled]="true"
              >
                <mat-chip
                  *ngFor="let object of emailFaxForm.get('related_to').value"
                  [removable]="false"
                >
                  <div [innerHTML]="optionFormatter(object) | safe : 'html'"></div>
                </mat-chip>
                <input
                  matInput
                  placeholder="Related To"
                  [readonly]="true"
                  [matChipInputFor]="chipList2"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                />
                <i
                  class="flaticon2-plus fa-xs px-2"
                  (click)="openSelectEntitiesDialog(2); $event.stopPropagation()"
                ></i>
              </mat-chip-list>
            </mat-form-field>
          </div>
        </div>
        <ng-template ngxPermissionsOnly="accessToTagCommunication" *ngIf="!data.reply">
          <div class="row mb-5">
            <div class="col col-sm-12">
              <kt-tags
                [controlObject]="tags"
                [appearance]="'outline'"
                [autocompleteEntity]="sendDocs ? 'DOCUMENT' : 'COMMUNICATION'"
                [canAddComponent]="true"
              ></kt-tags>
            </div>
          </div>
        </ng-template>
        <div class="row mb-5">
          <div class="col kt-margin-bottom-20-mobile" *ngIf="sendDocs">
            <kt-general-autocomplete
              [appearance]="'outline'"
              [label]="'EMAIL_FAX.SEARCH_TOPIC' | translate"
              [loadItemsFunction]="getDocs"
              [optionFormatter]="filterTopicFn"
              [valueFormatter]="filterTopicFn"
              [required]="!!data.document"
              [readOnly]="!!data.document"
              [control]="topicCtrl"
              [change]="selectedTopic.bind(this)"
              [dataPath]="'data'"
              [chipList]="true"
              [objects]="topicCtrl.value"
              [formatNewObjectFn]="formatNewTopicFn"
              #topicAutocomplete
            ></kt-general-autocomplete>
          </div>
          <div class="col kt-margin-bottom-20-mobile" *ngIf="!sendDocs">
            <mat-label class="mr-3">{{ 'EMAIL_FAX.ATTACHMENTS' | translate }}</mat-label>
            <input
              #fileInput
              type="file"
              name="attachments"
              (change)="onFileChange($event)"
              multiple
            />
            <i class="flaticon2-cross" *ngIf="files.length > 0" (click)="resetFileInput()"></i>
          </div>
        </div>
        <kt-custom-progress-bar
          *ngIf="showFileLoader | async"
          [requests]="uploadRequests"
          [totalFileSize]="totalFileSize"
          (callback)="callbackOnFileLoad()"
        ></kt-custom-progress-bar>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            (click)="close()"
            type="button"
            mat-raised-button
            cdkFocusInitial
            matTooltip="Cancel"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="clicked"
            (click)="reply ? replyTo() : submit()"
            matTooltip="Send"
          >
            <span translate="EMAIL_FAX.SEND">Send</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
